type ChildrenType = {
  type: unknown
  version: number
  children?: ChildrenType[]
  text?: string
  [k: string]: unknown
}

export type RichTextType = {
  root: {
    type: string
    children: ChildrenType[]
    direction: ('ltr' | 'rtl') | null
    format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
    indent: number
    version: number
  }
}

const extractTextFromNode = (node: ChildrenType): string => {
  if (!node || typeof node !== 'object') {
    return ''
  }

  // Extract text from text nodes
  if (node.type === 'text' && node.text) {
    return node.text
  }

  // Recursively extract text from child nodes
  if (Array.isArray(node.children)) {
    return node.children
      .map((child: ChildrenType) => extractTextFromNode(child))
      .join(' ')
      .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
      .trim()
  }

  // Fallback for other node types
  return ''
}

export const extractPlainText = (content: RichTextType | undefined): string => {
  if (!content || typeof content !== 'object') {
    // If the content is not an object, return an empty string
    return ''
  }

  // Check if the content is in Lexical's serialized editor state format
  if (content.root && Array.isArray(content.root.children)) {
    // Traverse the children of the root node
    return content.root.children
      .map((child: ChildrenType) => extractTextFromNode(child))
      .join(' ')
      .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
      .trim()
      .slice(0, 40000) // Limit to 40000 characters
  }

  // Fallback for other formats
  return ''
}
